import React from 'react';
import { View } from 'react-native';
import { twMerge } from 'tailwind-merge';

interface Props {
  length: number;
  step: number;
}

const SimpleSteps: React.FC<Props> = ({ length, step }) => {
  const steps: JSX.Element[] = [];

  let i = 1;

  while (i <= length) {
    const isCurrentStep = i === step;

    steps.push(
      <View
        key={i}
        className={twMerge(
          'h-[6px] mx-1',
          isCurrentStep
            ? 'w-6 rounded-md bg-primary-600'
            : 'w-[6px] rounded-md bg-gray-300'
        )}
      />
    );

    if (isCurrentStep) {
      i++;
    }

    i++;
  }

  return <View className="flex-row items-center m-1">{steps}</View>;
};

export default SimpleSteps;
